<template>
  <div style="max-width: 1160px;">
    <div class="m-t-6 row">
      <div class="flex fd-column jc-end col-md-4">
        Выберите дату:
        <div style="align-self: flex-start;">
          <datetime
            class="from-control"
            type="date"
            v-model="date"
            format="yyyy-MM-dd"
            @input="selectData"
          >
          </datetime>
        </div>
      </div>
      <div class="col-md-4 ta-center">
        
      </div>
    </div>
    <div class="timetable">
      <div class="timetable-items m-v-3 row" v-if="Object.keys(items).length">
        <figure class="item col-md-4" v-for="(disciplines, week) in timetable" :key="week" v-if="disciplines">
          <div class="timetable-item__wrapper">
            <div class="timetable-item__cap">
              {{week_titles[week-1]}}
            </div>
            <div class="timetable-item__list">
              <div class="timetable-item__list-wrapper" v-for="(item, key) in disciplines" :key="key">
                <div>
                  <div class="timetable-item__title">{{item.discipline.title}}</div>
                  <div class="timetable-item__name">{{item.customer.full_name}}</div>
                </div>
                <div class="time-content">
                  <span>{{item.schedule.from_at | mmSecondToSecond}}</span> 
                    - 
                  <span>{{item.schedule.till_at | mmSecondToSecond}}</span>
                </div>
              </div>
            </div>
          </div>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, errorNotify } from "@/plugins/functions";
export default {
  props: ["id"],
  data(){
    return {
      timetable: {},
      items: {},
      item: {},
      date: "",
      currentDate: "",
      templates: null,
      week_titles: [
        "Понедельник",
        "Вторник",
        "Среда",
        "Четверг",
        "Пятница",
        "Суббота",
        "Воскресенье",
      ]
    }
  },
  computed: {},
  components: {},
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async selectData(date){
      console.log('selectData', date)
      if(!date)
        return
      try {
        // let query = { ...this.$route.query };
        // query.start_week_date = new Date(date).toISOString().split('T')[0];
        let d = new Date(new Date(date).getTime() - (60*60*24*1000)*(new Date(date).getDay()-1))
        // console.log('dddd', d)
        this.items = {}
        this.timetable = []
        this.items = await this.cardContent(this.itemLink, '', {
          start_week_date: d.toISOString().split('T')[0],
        });
        this.items.forEach((e, i)=>{
          if(typeof this.timetable[e.week] == 'undefined')
            this.timetable[e.week] = []
          this.timetable[e.week].push(e)
        })
        // setTimeout(() => {
        //   this.$router.replace({ query: query });
        // }, 20);
      } catch (error) {}
    },
  },
  watch: {
    date(date){
      // let query = { ...this.$route.query };
      // query['start_week_date'] = new Date(date).toISOString().split('T')[0];
      // this.$router.replace({ query: query });
    },
  },
  async created() {
    if(!this.$store.state.business.id)
      console.log('None bid', this.$store.state)
    this.bid = this.$store.state.business.id
    let query = Object.assign({}, this.$route.query);
    this.itemLink = `${this.$store.state.secApiUrl}/schools/${this.bid}/classes/${this.id}/getWeekTimetableByDate`;

    if(query['start_week_date'])
      dateCurrent = new Date(query['start_week_date'])
    // this.currentDate = this.date.toISOString().split('T')[0]
  },
  mounted(){
    this.date = new Date().toISOString().split('T')[0]
    this.selectData(this.date)
  },
  beforeDestroy() {}
};
</script>
<style>
</style>
